var $ = require("jquery");

$(".header__menu__link").each(function () {
  var $self = $(this);

  $self.on("click", function (event) {
    event.preventDefault();
    var $id = $(this).attr("data-menu");
    var $activeCheck = $self.hasClass("active");

    if ($activeCheck == true) {
      $(".header__menu__link").removeClass("active");
      $(".menu").removeClass("active");
    } else {
      // Marker active
      $(".header__menu__link").removeClass("active");
      $(".header__menu__link--" + $id).addClass("active");

      // Content Active
      $(".menu").removeClass("active");
      $(".menu--" + $id).addClass("active");
    }
  });
});

// MOBILE

$(".header__menu__link--mobile").on("click", function (event) {
  event.preventDefault();
  $(".menu").toggleClass("active");
});

$(".menu").each(function () {
  var $self = $(this);
  var trigger = $self.find(".mobile__trigger");

  trigger.on("click", function (event) {
    var $activeCheck = $self.hasClass("mobile--open");
    if ($activeCheck == true) {
      event.preventDefault();
      $(".menu").removeClass("mobile--open");
    } else {
      event.preventDefault();
      $(".menu").removeClass("mobile--open");
      $self.addClass("mobile--open");
    }
  });
});
